<template>
  <div class="content animate-route">
    <banner bgColor="#d2d2d2" :title="title" :navShow="!keyword">
      <img src="@/assets/images/cleaf_banner5.jpg" slot="image" style="width: 100%" />
      <div class="nav" slot="nav">
        <div class="list" v-for="(item, index) in flowerType" :key="index">
          <span class="title" :class="item.value === currentId ? 'active' : ''" @click="changeType(item.value)">{{
            item.title
          }}</span>
        </div>
      </div>
    </banner>
    <!-- 花色 -->

    <a-row class="colour" type="flex">
      <a-col :span="24" v-if="keyword">
        <div class="keywordCount">为您搜索到结果 {{ total }} 条</div>
      </a-col>
      <a-col
        :xs="24"
        :sm="6"
        class="item animate-route"
        v-for="(item, index) in serieList"
        :key="index"
        @click="onDetails(item.id)"
      >
        <img :src="imgUrl + item.flowerImg" :alt="item.flowerTitle" />
        <div class="mask">
          <span class="title">{{ item.flowerTitle }}</span>
          <span class="title">{{ item.flowerType_dictText }}</span>
        </div>
      </a-col>
    </a-row>
    <a-row class="load">
      <a-col v-if="serieList.length > 0" :span="24">
        <span class="link" v-if="total === serieList.length">已经到底了~</span>
        <a-button v-else type="link" size="large" class="link" @click="nextPage">点击查看更多</a-button>
      </a-col>
      <!-- <a-empty class="nodata" v-else description="暂无数据"></a-empty> -->
    </a-row>
  </div>
</template>
<script>
import Banner from '@/components/Banner'
import { getDictByCode, getDecorList } from '@/api'
export default {
  name: 'Series',
  components: {
    Banner,
  },
  data() {
    return {
      title: {
        eng: 'DECOR SERIES',
        chs: '花色系列',
      },
      imgUrl: process.env.VUE_APP_IMG_URL,
      currentId: 0,
      flowerType: [],
      serieList: [],
      total: null,
      keyword: null,
      page: {
        pageNo: 1,
        pageSize: 16,
      },
    }
  },
  created() {
    this.currentId = this.$route.query.type | 0
    this.keyword = this.$route.query.keyword
    this.initData()
  },
  methods: {
    initData() {
      getDictByCode('flower_type').then((res) => {
        if (res.success) {
          this.flowerType = res.result
          this.flowerType.unshift({ value: 0, text: '花纹总览', title: '花纹总览' })
        }
      })
      this.getDecorData(this.currentId)
    },
    getDecorData(type) {
      let param = type === 0 ? { ...this.page } : { ...this.page, type }
      if (this.keyword) {
        param = { ...this.page, name: this.keyword }
      }
      getDecorList(param).then((res) => {
        if (res.success) {
          this.serieList = this.serieList.concat(res.result.records)
          this.total = res.result.total
        }
      })
    },
    nextPage() {
      this.page.pageNo += 1
      this.getDecorData(this.currentId)
    },
    onDetails(id) {
      const link = this.$router.resolve({ path: '/main/seriesdetails', query: { id } })
      window.open(link.href, '_blank')
    },
    changeType(id = '0') {
      this.currentId = id
      this.page.pageNo = 1
      this.serieList = []
      this.getDecorData(id)
    },
  },
}
</script>
<style lang="stylus" scoped>
@import './index'
route()
.content
  .nav
    menu()
  .colour
    max-width 1340px
    margin 0 auto
    padding 60px 0
    .keywordCount
      margin-bottom 24px
      font-weight bold
      font-size: 16px
    .item
      cursor pointer
      position relative
      overflow hidden
      width 335px
      height 335px
      &::after
        content ''
        position absolute
        display block
        width 100%
        height 100%
        top 0
        left 0
        background-color rgba(0, 0, 0, 0.3)
        visibility hidden
      &:hover::after
        visibility visible
      &:hover img
        transform scale(1.5)
      img
        width 335px
        height 335px
        transition all 0.5s
      .mask
        position absolute
        bottom 0
        width 335px
        z-index 100
        height 50px
        background-color rgba(0, 0, 0, 0.3)
        .title
          display block
          color #fff
          font-size 16px
  .load
    margin-bottom 60px
    .link
      color #666
      font-size 24px
</style>
